import { useState, useCallback, useEffect } from 'react';

const STORAGE_KEY = 'rfw_app_blocked_users';

export interface BlockedUserEntry {
  id: string;
  username: string;
  photoUrl: string;
  blockedAt: string;
  reason: string;
}

export function useBlockedUsers() {
  const [blockedUsers, setBlockedUsers] = useState<BlockedUserEntry[]>(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(blockedUsers));
  }, [blockedUsers]);

  const isBlocked = useCallback(
    (username: string) => blockedUsers.some((u) => u.username === username),
    [blockedUsers],
  );

  const blockUser = useCallback(
    (username: string, photoUrl: string, reason: string) => {
      setBlockedUsers((prev) => {
        if (prev.some((u) => u.username === username)) return prev;
        return [
          ...prev,
          {
            id: `block-${Date.now()}`,
            username,
            photoUrl,
            blockedAt: new Date().toISOString(),
            reason,
          },
        ];
      });
    },
    [],
  );

  const unblockUser = useCallback((username: string) => {
    setBlockedUsers((prev) => prev.filter((u) => u.username !== username));
  }, []);

  return { blockedUsers, isBlocked, blockUser, unblockUser };
}